import React from "react";
import {
    SectionCard,
    PaginationBar,
    inputClass,
    checkboxClass,
    saveButtonClass,
    primaryButtonClass,
} from "../adminShared";

const UsersTab = ({
    userSearch,
    setUserSearch,
    filteredUsers,
    usersPagination,
    goToUsersPage,
    userDrafts,
    setUserDrafts,
    working,
    saveUser,
    setUserDialogOpen,
}) => (
    <div className="flex flex-col gap-6 text-left">
        <SectionCard
            title="Create user"
            description="Create an account profile for an admin, support user, or manually provisioned user. Password is not required."
            right={
                <button
                    type="button"
                    className={`${primaryButtonClass} px-4`}
                    onClick={() => setUserDialogOpen(true)}
                >
                    Create user
                </button>
            }
        />

            <SectionCard
                title="Manage users"
                description="Search and edit users directly in the table, then save each row."
            right={
                <div className="w-full sm:w-72">
                    <input
                        className={inputClass}
                        value={userSearch}
                        onChange={(e) => setUserSearch(e.target.value)}
                        placeholder="Search users..."
                    />
                </div>
            }
            >
                <div className="overflow-x-auto rounded-xl border border-slate-200">
                    <table className="min-w-full text-left text-sm">
                        <thead className="bg-slate-50 text-slate-600">
                            <tr>
                                <th className="px-3 py-2">Email</th>
                                <th className="px-3 py-2">Username</th>
                                <th className="px-3 py-2">Phone</th>
                                <th className="px-3 py-2">Role</th>
                                <th className="px-3 py-2">Verified</th>
                                <th className="px-3 py-2">Status</th>
                                <th className="px-3 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200 bg-white">
                            {filteredUsers.map((user) => {
                                const draft = userDrafts[user.user_id] || {};
                                return (
                                    <tr key={user.user_id} className="align-top">
                                    <td className="px-3 py-2 min-w-[220px]">
                                        <input
                                            className={inputClass}
                                            value={draft.email || ""}
                                            onChange={(e) =>
                                                setUserDrafts((prev) => ({
                                                    ...prev,
                                                    [user.user_id]: {
                                                        ...prev[user.user_id],
                                                        email: e.target.value,
                                                    },
                                                }))
                                            }
                                            />
                                        </td>
                                    <td className="px-3 py-2 min-w-[160px]">
                                        <input
                                            className={inputClass}
                                            value={draft.username || ""}
                                            onChange={(e) =>
                                                setUserDrafts((prev) => ({
                                                    ...prev,
                                                    [user.user_id]: {
                                                        ...prev[user.user_id],
                                                        username: e.target.value,
                                                    },
                                                }))
                                            }
                                            />
                                        </td>
                                    <td className="px-3 py-2 min-w-[150px]">
                                        <input
                                            className={inputClass}
                                            value={draft.phone_number || ""}
                                            onChange={(e) =>
                                                setUserDrafts((prev) => ({
                                                    ...prev,
                                                    [user.user_id]: {
                                                        ...prev[user.user_id],
                                                        phone_number: e.target.value,
                                                    },
                                                }))
                                            }
                                            />
                                        </td>
                                    <td className="px-3 py-2 min-w-[130px]">
                                        <select
                                            className={inputClass}
                                            value={draft.role || "user"}
                                            onChange={(e) =>
                                                setUserDrafts((prev) => ({
                                                    ...prev,
                                                    [user.user_id]: {
                                                        ...prev[user.user_id],
                                                        role: e.target.value,
                                                    },
                                                }))
                                            }
                                        >
                                            <option value="user">User</option>
                                            <option value="admin">Admin</option>
                                            </select>
                                        </td>
                                    <td className="px-3 py-2 min-w-[108px]">
                                        <label className="flex h-10 items-center gap-2 rounded-xl border border-slate-200 px-3">
                                            <input
                                                type="checkbox"
                                                className={checkboxClass}
                                                aria-label="Email verified"
                                                checked={!!draft.email_verified}
                                                onChange={(e) =>
                                                    setUserDrafts((prev) => ({
                                                        ...prev,
                                                        [user.user_id]: {
                                                            ...prev[user.user_id],
                                                            email_verified: e.target.checked,
                                                        },
                                                    }))
                                                }
                                            />
                                        </label>
                                    </td>
                                    <td className="px-3 py-2 min-w-[108px]">
                                        <label className="flex h-10 items-center gap-2 rounded-xl border border-slate-200 px-3">
                                            <input
                                                type="checkbox"
                                                className={checkboxClass}
                                                aria-label="User status"
                                                checked={!!draft.is_active}
                                                onChange={(e) =>
                                                    setUserDrafts((prev) => ({
                                                        ...prev,
                                                        [user.user_id]: {
                                                            ...prev[user.user_id],
                                                            is_active: e.target.checked,
                                                        },
                                                    }))
                                                }
                                            />
                                        </label>
                                    </td>
                                    <td className="px-3 py-2 min-w-[112px]">
                                        <button
                                            className={saveButtonClass}
                                            onClick={() => saveUser(user.user_id)}
                                            disabled={working}
                                        >
                                            Save
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}

                        {filteredUsers.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="px-4 py-8 text-center text-slate-500">
                                    No users found.
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
            </div>
            <PaginationBar
                page={usersPagination.page}
                totalPages={usersPagination.total_pages}
                totalCount={usersPagination.total_count}
                totalLabel="users"
                onPrevious={() => goToUsersPage(usersPagination.page - 1)}
                onNext={() => goToUsersPage(usersPagination.page + 1)}
                disabled={working}
            />
        </SectionCard>
    </div>
);

export default UsersTab;
